import { useOnboardingStore } from "../useOnboardingStore";
import { RAIL_STEPS } from "./steps";

/** PlayerStatus from the squawk player, restated so this module stays light. */
export type SquawkStatus =
  | "idle"
  | "connecting"
  | "connected"
  | "error"
  | "disconnected";

/**
 * Should the squawk button be marked right now?
 *
 * WidgetSpotlightContext cannot do this job. It is keyed on a grid id and
 * consumed by WidgetContainer, and the squawk button is app chrome with neither
 * — but the harder constraint is position: Header renders ABOVE both gates in
 * App.jsx, so a context provided by OnboardingGate could never reach it. A hook
 * reading the store is forced, not stylistic. The demo guide's useDemoNavTarget
 * marks a sidebar nav item the same way for the same reason.
 *
 * `status` is passed in rather than read from SquawkPlayerContext for two
 * reasons: this module stays clear of that file's any-typed .d.ts shim, and the
 * caller physically cannot hand it the button's 500ms-debounced `visualState`
 * by accident.
 *
 * YIELDS to error and connecting. .nq-demo-pulse sets background-color with
 * !important, and the button's error state is bg-red-600 + animate-bounce —
 * without this guard the onboarding hint paints over the alarm, and a user
 * whose squawk has just died gets a friendly blue "click me" instead of the
 * red bounce that tells them something is wrong.
 */
export function useOnboardingSquawkPulse(status: SquawkStatus): boolean {
  const rail = useOnboardingStore((s) => s.state?.rail);

  // Yield first: the alarm and the connecting spinner both outrank a hint.
  if (status !== "idle" && status !== "disconnected") return false;
  if (!rail || rail.completedAt || rail.exitedAt) return false;

  const step = RAIL_STEPS.find((s) => s.id === rail.stepIds[rail.step]);
  return step?.chrome === "squawk";
}
